import "isomorphic-fetch";

var md5 = require("blueimp-md5");

const API_URL = process.env.REACT_APP_API_HOST;
const STATIC_URL = process.env.REACT_APP_STATIC_HOST;
const STATIC_HASH = process.env.REACT_APP_RESIZE_KEY;

class Api {
    static buildParams(params) {
        let str = [];
        for (let p in params)
            if (params.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
            }
        return str.join("&");
    }

    static request(url, method, params = {}, body = {}, headers = {}, raw = false) {
        url = API_URL + url + '?' + this.buildParams(params);

        headers['Accept'] = 'application/json';
        headers['Content-Type'] = 'application/json';

        return timeoutPromise(30000, fetch(url, {
            method: method,
            body: method === 'GET' ? null : JSON.stringify(body),
            headers: headers,
        })).then(response => {
            return raw ? response : response.json();
        });
    }

    static get(url, params, headers = {}, raw = false) {
        return this.request(url, 'GET', params, {}, headers, raw);
    }

    static post(url, body) {
        return this.request(url, 'POST', {}, body);
    }

    static restaurants(params = {}) {
        return this.get('restaurants', params);
    }

    static news(params = {}) {
        return this.get('news', params, {}, true).then((response) => {
            const result = getPaginationInfo(response.headers);

            return response.json().then(function (data) {
                result.items = data;
                return result;
            }).catch(function (error) {
                console.log(error);
            });
        });
    }

    static media(params = {}) {
        return this.get('media', params, {}, true).then((response) => {
            const result = getPaginationInfo(response.headers);

            return response.json().then(function (data) {
                result.items = data;
                return result;
            }).catch(function (error) {
                console.log(error);
            });
        });
    }

    static galleries(params = {}) {
        params.expand = 'publishedPhotos';

        return this.get('galleries', params, {}, true).then((response) => {
            const result = getPaginationInfo(response.headers);

            return response.json().then(function (data) {
                result.items = data;
                return result;
            }).catch(function (error) {
                console.log(error);
            });
        });
    }

    static getImage(file, action = null, width = null, height = null) {
        if (!file) {
            return null;
        }

        width = width === null ? '-' : width;
        height = height === null ? '-' : height;

        if (action) {
            const path = width + 'x' + height + '/' + file;
            const hash = md5(path + STATIC_HASH);
            return STATIC_URL + action + '/' + hash + '/' + path;
        } else {
            return STATIC_URL + file;
        }
    }
}

function getPaginationInfo(headers) {
    if (headers.has('X-Pagination-Current-Page')) {
        return {
            currentPage: parseInt(headers.get('X-Pagination-Current-Page'), 10),
            pageCount: parseInt(headers.get('X-Pagination-Page-Count'), 10),
            perPage: parseInt(headers.get('X-Pagination-Per-Page'), 10),
            totalCount: parseInt(headers.get('X-Pagination-Total-Count'), 10),
        }
    }

    return {};
}

function timeoutPromise(ms, promise) {
    return new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
            reject(new Error("promise timeout"))
        }, ms);
        promise.then(
            (res) => {
                clearTimeout(timeoutId);
                resolve(res);
            },
            (err) => {
                clearTimeout(timeoutId);
                reject(err);
            }
        );
    })
}

export default Api;


// WEBPACK FOOTER //
// ./src/js/Api.js